import React from 'react'
import useTreeCheckbox from './useTreeCheckbox'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Collapse from '@material-ui/core/Collapse'
import Checkbox from '@material-ui/core/Checkbox'
import Grid from '@material-ui/core/Grid'
import { Typography } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { NewReturnListFileType } from '../../component/web/shareUI/uploadDoc/uploadFile/uploadFileType'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import path from 'path'
import { fileExt as fileExtConst } from '../../constants/constants'
type FileInfoType = {
    topicID: number
    fileID: number
    fileToken: string
    filename: string
    isStamp: boolean
    path: string
}[]
export type DataSourceType = {
    topicCode: null | string
    topicID: number
    topicName_en: string
    topicName_th: string
    topicNo: number
    subtopicInfo?: []
    fileInfo: FileInfoType[]
}
type SelectedListWithLangType = { fileID: number; language: string }
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        // maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
}))
let TreeCheckboxView: React.FC<any> = ({
    dataSource,
    field,
    required,
    disabled,
    isLangTH = true,
    labelRadioTH = 'ไทย',
    labelRadioEN = 'อังกฤษ',
    onClickFile,
    ...other
}) => {
    const { input, meta } = field

    const classes = useStyles()

    const [open, setOpen] = React.useState(true)
    const [selectedList, setSelectedList] = React.useState({
        parentSelected: [],
        childSelected: [],
    })
    const [selectedListWithLang, setSelectedListWithLang] = React.useState<SelectedListWithLangType[]>([])

    React.useEffect(() => {
        // console.log('meta.initial : ', meta.initial)
        if (meta.initial) {
            if (meta.initial.childSelected.length > 0 || meta.initial.parentSelected.length > 0) {
                setSelectedList({
                    ...selectedList,
                    childSelected: meta.initial.childSelected,
                    parentSelected: meta.initial.parentSelected,
                })

                //set initial value in final-form
                const formChange = meta.initial.childSelected.map((itm: any) => ({
                    fileID: itm?.fileID,
                    language: itm?.language || 'th',
                }))
                input.onChange(formChange)
            }
        }
    }, [meta.initial])

    React.useEffect(() => {
        // 'ทำ initial ภาษา '
        let initFileLang: SelectedListWithLangType[] = []

        if (dataSource && dataSource.length > 0) {
            dataSource.forEach((dataItm: any) => {
                dataItm.fileInfo.forEach((file: any) => {
                    initFileLang.push({
                        fileID: file?.fileID,
                        language: file?.language ? file?.language : 'th',
                    })
                })
            })
        }
        setSelectedListWithLang(initFileLang)
    }, [dataSource])

    const handleClick = () => {
        setOpen(!open)
    }
    const isParentCheckedFn = (data: any) => {
        const { parentSelected, childSelected } = selectedList
        const isChecked = parentSelected.filter((itm: any) => itm.topicID === data.topicID).length > 0

        return isChecked
    }

    const isChildrenCheckedFn = (data: any) => {
        const { childSelected } = selectedList
        const isChecked = childSelected.filter((itm: any) => itm.fileID === data.fileID).length > 0

        return isChecked
    }
    const isAllChildCheckedFn = (topicID: number) => {
        const { childSelected } = selectedList
        const topicData = dataSource.filter((itm: any) => itm.topicID === topicID)

        const allChildNum = topicData.length > 0 ? topicData[0].fileInfo.length : 0 //จำนวนลูกทั้งหมดที่มี
        const currentChildSelectedNum = childSelected.filter((itm: any) => itm.topicID === topicID).length + 1 //จำนวนลูกทั้งหมดที่ถูกติ๊กเลือกอยู่

        const isAllChildChecked = allChildNum === currentChildSelectedNum ? true : false

        return isAllChildChecked
    }

    const setSelectedFileWithLang = (newSelectedList: any[]) => {
        // กรณีติ๊กเลือกไฟล์ก่อนเลือกภาษาจะ set default ภาษา ให้เป็น TH  //
        //@ts-ignore
        const fileIDSelectedLst = newSelectedList.childSelected.map((itm: any) => itm.fileID)
        const filtered = selectedListWithLang?.filter(function (e: any, index: number) {
            return fileIDSelectedLst.indexOf(e.fileID) > -1
        })
        let newLangValue = []
        if (filtered.length === 0) {
            newLangValue = fileIDSelectedLst.map((fileID: number) => {
                return {
                    fileID: fileID,
                    language: 'TH',
                }
            })
        }
        const newSelectedListWithLang = [...selectedListWithLang, ...newLangValue]
        return newSelectedListWithLang
    }
    const getFilterChildDataOnlyPdf = (childDataList: any) => {
        const filterChildDataList = childDataList.filter((itm: any) => {
            return path.extname(`${itm.filename}`) === fileExtConst.pdf
        })
        return filterChildDataList
    }
    const handleCheckedParent = (data: any) => () => {
        const { parentSelected, childSelected } = selectedList
        const isChecked = isParentCheckedFn(data)
        let newSelectedList = {}
        // --- case 1 มีการติ๊กอยู่ (ให้เอาติ๊กออกพร้อมกับเอาติ๊กลูกออกทั้งหมด) --- //
        if (isChecked) {
            const newParentList = parentSelected.filter((itm: any) => itm.topicID !== data.topicID)
            const newChildList = childSelected.filter((itm: any) => itm.topicID !== data.topicID)
            newSelectedList = {
                ...selectedList,
                parentSelected: newParentList,
                childSelected: newChildList, //[...childSelected, ...newChildList],
            }
        }

        // --- case 2 ไม่ได้ติ๊กอยู่ (ให้ติ๊กพร้อมกับติ๊กลูกทั้งหมด) --- //
        else {
            newSelectedList = {
                ...selectedList,
                parentSelected: [...parentSelected, { ...data }],
                childSelected: [...childSelected, ...data.fileInfo],
            }
        }

        //กรณีติ๊กเลือก all ต้องไป filter เอาเฉพาะไฟล์ pdf มาก่อน
        const filterdDataOnlyPdf = {
            ...newSelectedList,
            //@ts-ignore
            childSelected: getFilterChildDataOnlyPdf(newSelectedList?.childSelected),
        }
        //@ts-ignore
        const newSelectedListWithLang = setSelectedFileWithLang(filterdDataOnlyPdf)
        setSelectedListWithLang(newSelectedListWithLang)
        //@ts-ignore
        setSelectedList(filterdDataOnlyPdf)
        changeInputValue(filterdDataOnlyPdf, newSelectedListWithLang)
    }

    const handleCheckedChild = (data: any) => () => {
        const { parentSelected, childSelected } = selectedList

        const isChecked = isChildrenCheckedFn(data)
        const isAllChildChecked = isAllChildCheckedFn(data.topicID)
        let newSelectedList = {}

        // --- case 1 มีการติ๊กอยู่ (ให้เอาติ๊กออกพร้อมกับเอาติ๊กพ่อออก) --- //
        if (isChecked) {
            const newParentList = parentSelected.filter((itm: any) => itm.topicID !== data.topicID)
            const newChildList = childSelected.filter((itm: any) => itm.fileID !== data.fileID)
            newSelectedList = {
                ...selectedList,
                parentSelected: newParentList,
                childSelected: newChildList,
            }
        }

        // --- case 2 ไม่ได้ติ๊กอยู่ (ให้ติ๊กพร้อมกับเช็คว่าลูกทั้งหมดถูกติ๊กอยู่หรือไม่) --- //
        else {
            const newParentList = dataSource.filter((itm: any) => itm.topicID === data.topicID)

            if (isAllChildChecked) {
                //      true  => ถ้าลูกทั้งหมดถูกติ๊กอยู่ให้ติ๊กพ่อด้วย
                newSelectedList = {
                    ...selectedList,
                    parentSelected: [...parentSelected, ...newParentList],
                    childSelected: [...childSelected, { ...data }],
                }
            } else {
                //      false => ถ้าลูกไม่ได้ถูกติ๊กทั้งหมดไม่ต้องทำอะไรกับพ่อ
                newSelectedList = {
                    ...selectedList,
                    childSelected: [...childSelected, { ...data }],
                }
            }
        }

        //@ts-ignore
        const newSelectedListWithLang = setSelectedFileWithLang(newSelectedList)
        //@ts-ignore
        setSelectedList(newSelectedList)
        // changeInputValue(newSelectedList, selectedListWithLang)
        setSelectedListWithLang(newSelectedListWithLang)
        changeInputValue(newSelectedList, newSelectedListWithLang)
    }

    const changeInputValue = (newSelectedList: any, langValueList: any) => {
        let dataForReturn
        const fileIDSelectedLst = newSelectedList.childSelected.map((itm: any) => itm.fileID)
        const filtered = langValueList?.filter(function (e: any, index: number) {
            return fileIDSelectedLst.indexOf(e.fileID) > -1
        })
        dataForReturn = filtered

        input.onChange(dataForReturn)
    }

    const renderIcon = (filename: any) => {
        const fileExt = path.extname(`${filename || ''}`)
        let iconPath = ''
        switch (fileExt) {
            case fileExtConst.pdf:
                iconPath = '/img/icons/pdf.png'
                break
            case fileExtConst.doc:
                iconPath = '/img/icons/word.png'
                break
            case fileExtConst.docx:
                iconPath = '/img/icons/word.png'
                break
            case fileExtConst.tiff:
                iconPath = '/img/icons/other_docs.png'
                break
            case fileExtConst.png:
                iconPath = '/img/icons/other_docs.png'
                break
            case fileExtConst.jpg:
                iconPath = '/img/icons/other_docs.png'
                break
            case fileExtConst.xls:
                iconPath = '/img/icons/excel.png'
                break
            case fileExtConst.xlsx:
                iconPath = '/img/icons/excel.png'
                break
            default:
                iconPath = '/img/icons/pdf.png'
                break
        }

        return (
            <img
                src={process.env.PUBLIC_URL + iconPath}
                alt="pdf"
                style={{ width: 24, height: 24, margin: 4, marginRight: 10 }}
            />
        )
    }
    const handleChangeLang = (lang: string, fileItm: any) => {
        const formatedValue = {
            fileID: fileItm.fileID,
            language: lang,
        }
        const isHaveLang = selectedListWithLang.filter((itm: any) => itm.fileID === fileItm.fileID).length > 0
        let newSelectedListWithLang
        if (isHaveLang) {
            newSelectedListWithLang = selectedListWithLang.map((itm) => {
                if (itm.fileID === fileItm.fileID) {
                    return { ...itm, language: formatedValue.language }
                } else {
                    return itm
                }
            })
            // setSelectedListWithLang(newSelectedListWithLang)
        } else {
            newSelectedListWithLang = [...selectedListWithLang, formatedValue]
            // setSelectedListWithLang(newSelectedListWithLang)
        }
        changeInputValue(selectedList, newSelectedListWithLang)
        setSelectedListWithLang(newSelectedListWithLang)

        // const  selectedListWithLang
    }

    const handleClickFile = (filename: string) => {
        const fileExt = path.extname(`${filename}`)
        if (onClickFile) {
            onClickFile(filename, fileExt)
        }
    }
    const checkedRadioFn = (fileID: number) => {
        let isCheckedTH = false
        selectedListWithLang.forEach((itm) => {
            if (itm.fileID === fileID && itm.language === 'th') isCheckedTH = true
        })
        let isCheckedEN = false
        selectedListWithLang.forEach((itm) => {
            if (itm.fileID === fileID && itm.language === 'en') isCheckedEN = true
        })

        return { isCheckedTH, isCheckedEN }
    }
    const checkDisableRadio = (fileID: number) => {
        let isDisableRadio = true
        selectedList.childSelected.forEach((itm: any) => {
            if (itm?.fileID !== fileID && isDisableRadio) {
                //ไฟล์ไม่ถูกเลือกอยู่ isDisableRadio = true
                isDisableRadio = true
            } else {
                //ไฟล์ถูกเลือกอยู่ isDisableRadio = false
                isDisableRadio = false
            }
        })
        return isDisableRadio
    }
    const renderFileList = (fileList: any) => {
        return fileList.map((fileItm: any) => {
            const isChecked = isChildrenCheckedFn(fileItm)
            const fileExt = path.extname(`${fileItm?.filename}`)
            const { isCheckedTH, isCheckedEN } = checkedRadioFn(fileItm.fileID)
            const isDisableRadio = false //checkDisableRadio(fileItm.fileID) //feature นี้สำหรับ disable radio เมื่อไม่ได้มีการติ๊กเลือกไฟล์นี้

            return (
                <>
                    <ListItem className={classes.nested}>
                        <ListItemIcon>
                            {fileExt === fileExtConst.pdf && (
                                <Checkbox
                                    disabled={disabled}
                                    checked={isChecked}
                                    onChange={handleCheckedChild(fileItm)}
                                />
                            )}
                        </ListItemIcon>
                        <Grid item xs={12}>
                            <Paper variant="outlined" style={{ padding: '5px', margin: '5px', marginRight: '0px' }}>
                                <Grid container>
                                    <Grid container item xs={9} alignItems="center">
                                        {renderIcon(fileItm.filename)}
                                        <Typography variant={'body2'}>
                                            <a
                                                href={fileItm.path}
                                                target="_blank"
                                                onClick={() => {
                                                    handleClickFile(fileItm.filename)
                                                }}
                                            >
                                                {fileItm.filename}
                                            </a>
                                        </Typography>
                                    </Grid>
                                    {fileExt === fileExtConst.pdf && (
                                        <Grid container item xs={3} alignItems="center">
                                            <RadioGroup
                                                row
                                                aria-label="position"
                                                name="position"

                                                // defaultValue={fileItm.language ? fileItm.language : 'th'}
                                            >
                                                <FormControlLabel
                                                    value="th"
                                                    control={<Radio color="primary" checked={isCheckedTH} />}
                                                    label={labelRadioTH}
                                                    labelPlacement="end"
                                                    disabled={disabled || isDisableRadio}
                                                    onChange={(e: any) => {
                                                        handleChangeLang(e.target.value, fileItm)
                                                    }}
                                                />
                                                <FormControlLabel
                                                    value="en"
                                                    control={<Radio color="primary" checked={isCheckedEN} />}
                                                    label={labelRadioEN}
                                                    labelPlacement="end"
                                                    disabled={disabled || isDisableRadio}
                                                    onChange={(e: any) => {
                                                        handleChangeLang(e.target.value, fileItm)
                                                    }}
                                                />
                                            </RadioGroup>
                                        </Grid>
                                    )}
                                </Grid>
                            </Paper>
                        </Grid>
                    </ListItem>
                </>
            )
        })
    }

    const renderElement = (dataSource: any) => {
        return dataSource.map((data: any) => {
            const isChecked = isParentCheckedFn(data)
            return (
                <>
                    {/*  loop 1  Topic */}
                    <ListItem onClick={handleClick}>
                        <ListItemIcon>
                            <Checkbox disabled={disabled} checked={isChecked} onChange={handleCheckedParent(data)} />
                        </ListItemIcon>
                        <ListItemText
                            primary={`${data.topicNo}. ${isLangTH ? data.topicName_th : data.topicName_en}`}
                        />
                    </ListItem>
                    <Collapse in={true} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {/* /* loop 2 chrildren file*/}
                            {renderFileList(data.fileInfo)}
                        </List>
                    </Collapse>
                </>
            )
        })
    }

    return (
        <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
            {renderElement(dataSource)}
        </List>
    )
}

let TreeCheckboxCtrl: React.FC<any> = ({ name, ...others }) => {
    const styleCustom = { minWidth: '125px', ...others?.style }
    const treeCheckboxModel = useTreeCheckbox({
        name,
        ...others,
    })
    return <TreeCheckboxView {...others} {...treeCheckboxModel} style={styleCustom} />
}

export default TreeCheckboxCtrl
